/*
  Shipping calculator on the shipping page (snippets/shipping-calculator.liquid).
  Looks up the selected country in the zones (rates in EUR) and shows cost, free-shipping threshold and delivery time.
  When the visitor shops in another currency, an approximate converted amount is added using the store's own rate.
*/
if (!customElements.get('shipping-calculator')) {
  customElements.define(
    'shipping-calculator',
    class ShippingCalculator extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-country]');
        try {
          this.zones = JSON.parse(this.querySelector('[data-zones]').textContent);
        } catch (e) {
          this.zones = [];
        }
        this.eu = (this.dataset.eu || '').split(',').filter(Boolean);
        this.select.addEventListener('change', () => this.update());
        this.update();
      }

      format(amount, currency, rate = 1) {
        const value = amount * rate;
        const whole = Number.isInteger(value);
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency,
          minimumFractionDigits: whole ? 0 : 2,
          maximumFractionDigits: whole ? 0 : 2,
        }).format(value);
      }

      price(amount) {
        const eur = this.format(amount, 'EUR');
        const active = window.Shopify && Shopify.currency && Shopify.currency.active;
        const rate = active && parseFloat(Shopify.currency.rate);
        if (!active || active === 'EUR' || !rate) return eur;
        return `${eur} (${this.dataset.about} ${this.format(amount, active, rate)})`;
      }

      update() {
        const country = this.select.value;
        const zone = this.zones.find((z) => z.countries.includes(country));
        const result = this.querySelector('[data-result]');

        this.querySelector('[data-unknown]').hidden = !!zone;
        this.querySelector('[data-customs]').hidden = !zone || this.eu.includes(country);
        result.hidden = !zone;
        if (!zone) return;

        const rate = parseFloat(zone.rate) || 0;
        const freeOver = zone.freeOver === null || zone.freeOver === '' ? null : parseFloat(zone.freeOver);
        this.querySelector('[data-cost]').textContent = rate > 0 ? this.price(rate) : this.dataset.free;
        this.querySelector('[data-free-row]').hidden = rate === 0 || freeOver === null;
        if (freeOver !== null) this.querySelector('[data-free-over]').textContent = `${this.dataset.above} ${this.price(freeOver)}`;
        this.querySelector('[data-time-row]').hidden = !zone.time;
        this.querySelector('[data-time]').textContent = zone.time || '';
      }
    }
  );
}
